import { render } from "./ErrorView.vue?vue&type=template&id=a177e666&scoped=true"
import script from "./ErrorView.vue?vue&type=script&lang=js"
export * from "./ErrorView.vue?vue&type=script&lang=js"

import "./ErrorView.vue?vue&type=style&index=0&id=a177e666&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-a177e666"

export default script